<template>
    <base-card class="zapServiceBox">
        <div class="flex flex-col sm:flex-row items-start sm:items-end">
            <div class="flex flex-col text-gray-700 tracking-wide">
                <span class="text-sm">{{ subTitle }}</span>
                <span class="font-bold text-lg">{{ name }}</span>
            </div>
            <div class="ml-auto">
                <div v-if="operational">
                    <a :href="this.detailRoute()" class="boxLink" :title="'Show ' + subTitle + ' ' + name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" class="text-green-400" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                    </a>
                </div>
                <div v-if="decreased">
                    <a :href="this.detailRoute()" class="boxLink" :title="'Show ' + subTitle + ' ' + name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" class="text-orange-500" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                    </a>
                </div>
                <div v-if="interrupted">
                    <a :href="this.detailRoute()" class="boxLink" :title="'Show ' + subTitle + ' ' + name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" class="text-red-500" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </base-card>
</template>

<script>
    export default {
        props: {
            subTitle: {
                required: true,
                type: String,
            },
            name: {
                required: true,
                type: String,
            },
            status: {
                required: true,
                type: String,
            },
            serviceId: {
                required: true,
                type: String,
            },
            interruptionId: {
                required: true,
                type: String|null,
            },
        },
        computed: {
            operational() {
                return this.status === "normal";
            },
            decreased() {
                return this.status === "warning";
            },
            interrupted() {
                return this.status === "interruption";
            },
        },
        methods: {
            detailRoute() {
                return route('service.show', {
                    service: this.serviceId
                });
            },
        },
    }
</script>
